export default [
  {
    "codenumber": 0,
    "symbol": String.fromCharCode(parseInt('\u0000',16)),
    "description": "NULL CHAR"
  },
  {
    "codenumber": 1,
    "symbol": String.fromCharCode(parseInt('\u0001',16)),
    "description": "START OF HEADING"
  },
  {
    "codenumber": 2,
    "symbol": String.fromCharCode(parseInt('\u0002',16)),
    "description": "START OF TEXT"
  },
  {
    "codenumber": 3,
    "symbol": String.fromCharCode(parseInt('\u0003',16)),
    "description": "END OF TEXT"
  },
  {
    "codenumber": 4,
    "symbol": String.fromCharCode(parseInt('\u0004',16)),
    "description": "END OF TRANSMISSION"
  },
  {
    "codenumber": 5,
    "symbol": String.fromCharCode(parseInt('\u0005',16)),
    "description": "ENQUIRY"
  },
  {
    "codenumber": 6,
    "symbol": String.fromCharCode(parseInt('\u0006',16)),
    "description": "ACKNOWLEDGMENT"
  },
  {
    "codenumber": 7,
    "symbol": String.fromCharCode(parseInt('\u0007',16)),
    "description": "BELL"
  },
  {
    "codenumber": 8,
    "symbol": String.fromCharCode(parseInt('\u0008',16)),
    "description": "BACK SPACE"
  },
  {
    "codenumber": 9,
    "symbol": String.fromCharCode(parseInt('\u0009',16)),
    "description": "HORIZONTAL TAB"
  },
  {
    "codenumber": 10,
    "symbol": String.fromCharCode(parseInt('\u000A',16)),
    "description": "LINE FEED"
  },
  {
    "codenumber": 11,
    "symbol": String.fromCharCode(parseInt('\u000B',16)),
    "description": "VERTICAL TAB"
  },
  {
    "codenumber": 12,
    "symbol": String.fromCharCode(parseInt('\u000C',16)),
    "description": "FORM FEED"
  },
  {
    "codenumber": 13,
    "symbol": String.fromCharCode(parseInt('\u000D',16)),
    "description": "CARRIAGE RETURN"
  },
  {
    "codenumber": 14,
    "symbol": String.fromCharCode(parseInt('\u000E',16)),
    "description": "SHIFT OUT / X-ON"
  },
  {
    "codenumber": 15,
    "symbol": String.fromCharCode(parseInt('\u000F',16)),
    "description": "SHIFT IN / X-OFF"
  },
  {
    "codenumber": 16,
    "symbol": String.fromCharCode(parseInt('\u0010',16)),
    "description": "DATA LINE ESCAPE"
  },
  {
    "codenumber": 17,
    "symbol": String.fromCharCode(parseInt('\u0011',16)),
    "description": "DEVICE CONTROL 1 (OFT. XON)"
  },
  {
    "codenumber": 18,
    "symbol": String.fromCharCode(parseInt('\u0012',16)),
    "description": "DEVICE CONTROL 2"
  },
  {
    "codenumber": 19,
    "symbol": String.fromCharCode(parseInt('\u0013',16)),
    "description": "DEVICE CONTROL 3 (OFT. XOFF)"
  },
  {
    "codenumber": 20,
    "symbol": String.fromCharCode(parseInt('\u0014',16)),
    "description": "DEVICE CONTROL 4"
  },
  {
    "codenumber": 21,
    "symbol": String.fromCharCode(parseInt('\u0015',16)),
    "description": "NEGATIVE ACKNOWLEDGEMENT"
  },
  {
    "codenumber": 22,
    "symbol": String.fromCharCode(parseInt('\u0016',16)),
    "description": "SYNCHRONOUS IDLE"
  },
  {
    "codenumber": 23,
    "symbol": String.fromCharCode(parseInt('\u0017',16)),
    "description": "END OF TRANSMIT BLOCK"
  },
  {
    "codenumber": 24,
    "symbol": String.fromCharCode(parseInt('\u0018',16)),
    "description": "CANCEL"
  },
  {
    "codenumber": 25,
    "symbol": String.fromCharCode(parseInt('\u0019',16)),
    "description": "END OF MEDIUM"
  },
  {
    "codenumber": 26,
    "symbol": String.fromCharCode(parseInt('\u001A',16)),
    "description": "SUBSTITUTE"
  },
  {
    "codenumber": 27,
    "symbol": String.fromCharCode(parseInt('\u001B',16)),
    "description": "ESCAPE"
  },
  {
    "codenumber": 28,
    "symbol": String.fromCharCode(parseInt('\u001C',16)),
    "description": "FILE SEPARATOR"
  },
  {
    "codenumber": 29,
    "symbol": String.fromCharCode(parseInt('\u001D',16)),
    "description": "GROUP SEPARATOR"
  },
  {
    "codenumber": 30,
    "symbol": String.fromCharCode(parseInt('\u001E',16)),
    "description": "RECORD SEPARATOR"
  },
  {
    "codenumber": 31,
    "symbol": String.fromCharCode(parseInt('\u001F',16)),
    "description": "UNIT SEPARATOR"
  },
  
  {
    "codenumber": 32,
    "symbol": " ",
    "description": "SPACE"
  },
  {
    "codenumber": 33,
    "symbol": "!",
    "description": "EXCLAMATION MARK"
  },
  {
    "codenumber": 34,
    "symbol": "\"",
    "description": "QUOTATION MARK"
  },
  {
    "codenumber": 35,
    "symbol": "#",
    "description": "NUMBER SIGN"
  },
  {
    "codenumber": 36,
    "symbol": "$",
    "description": "DOLLAR SIGN"
  },
  {
    "codenumber": 37,
    "symbol": "%",
    "description": "PERCENT SIGN"
  },
  {
    "codenumber": 38,
    "symbol": "&",
    "description": "AMPERSAND"
  },
  {
    "codenumber": 39,
    "symbol": "'",
    "description": "APOSTROPHE"
  },
  {
    "codenumber": 40,
    "symbol": "(",
    "description": "LEFT PARENTHESIS"
  },
  {
    "codenumber": 41,
    "symbol": ")",
    "description": "RIGHT PARENTHESIS"
  },
  {
    "codenumber": 42,
    "symbol": "*",
    "description": "ASTERISK"
  },
  {
    "codenumber": 43,
    "symbol": "+",
    "description": "PLUS SIGN"
  },
  {
    "codenumber": 44,
    "symbol": ",",
    "description": "COMMA"
  },
  {
    "codenumber": 45,
    "symbol": "-",
    "description": "HYPHEN-MINUS"
  },
  {
    "codenumber": 46,
    "symbol": ".",
    "description": "FULL STOP"
  },
  {
    "codenumber": 47,
    "symbol": "/",
    "description": "SOLIDUS"
  },
  {
    "codenumber": 48,
    "symbol": "0",
    "description": "DIGIT ZERO"
  },
  {
    "codenumber": 49,
    "symbol": "1",
    "description": "DIGIT ONE"
  },
  {
    "codenumber": 50,
    "symbol": "2",
    "description": "DIGIT TWO"
  },
  {
    "codenumber": 51,
    "symbol": "3",
    "description": "DIGIT THREE"
  },
  {
    "codenumber": 52,
    "symbol": "4",
    "description": "DIGIT FOUR"
  },
  {
    "codenumber": 53,
    "symbol": "5",
    "description": "DIGIT FIVE"
  },
  {
    "codenumber": 54,
    "symbol": "6",
    "description": "DIGIT SIX"
  },
  {
    "codenumber": 55,
    "symbol": "7",
    "description": "DIGIT SEVEN"
  },
  {
    "codenumber": 56,
    "symbol": "8",
    "description": "DIGIT EIGHT"
  },
  {
    "codenumber": 57,
    "symbol": "9",
    "description": "DIGIT NINE"
  },
  {
    "codenumber": 58,
    "symbol": ":",
    "description": "COLON"
  },
  {
    "codenumber": 59,
    "symbol": ";",
    "description": "SEMICOLON"
  },
  {
    "codenumber": 60,
    "symbol": "<",
    "description": "LESS-THAN SIGN"
  },
  {
    "codenumber": 61,
    "symbol": "=",
    "description": "EQUALS SIGN"
  },
  {
    "codenumber": 62,
    "symbol": ">",
    "description": "GREATER-THAN SIGN"
  },
  {
    "codenumber": 63,
    "symbol": "?",
    "description": "QUESTION MARK"
  },
  {
    "codenumber": 64,
    "symbol": "@",
    "description": "COMMERCIAL AT"
  },
  {
    "codenumber": 65,
    "symbol": "A",
    "description": "LATIN CAPITAL LETTER A"
  },
  {
    "codenumber": 66,
    "symbol": "B",
    "description": "LATIN CAPITAL LETTER B"
  },
  {
    "codenumber": 67,
    "symbol": "C",
    "description": "LATIN CAPITAL LETTER C"
  },
  {
    "codenumber": 68,
    "symbol": "D",
    "description": "LATIN CAPITAL LETTER D"
  },
  {
    "codenumber": 69,
    "symbol": "E",
    "description": "LATIN CAPITAL LETTER E"
  },
  {
    "codenumber": 70,
    "symbol": "F",
    "description": "LATIN CAPITAL LETTER F"
  },
  {
    "codenumber": 71,
    "symbol": "G",
    "description": "LATIN CAPITAL LETTER G"
  },
  {
    "codenumber": 72,
    "symbol": "H",
    "description": "LATIN CAPITAL LETTER H"
  },
  {
    "codenumber": 73,
    "symbol": "I",
    "description": "LATIN CAPITAL LETTER I"
  },
  {
    "codenumber": 74,
    "symbol": "J",
    "description": "LATIN CAPITAL LETTER J"
  },
  {
    "codenumber": 75,
    "symbol": "K",
    "description": "LATIN CAPITAL LETTER K"
  },
  {
    "codenumber": 76,
    "symbol": "L",
    "description": "LATIN CAPITAL LETTER L"
  },
  {
    "codenumber": 77,
    "symbol": "M",
    "description": "LATIN CAPITAL LETTER M"
  },
  {
    "codenumber": 78,
    "symbol": "N",
    "description": "LATIN CAPITAL LETTER N"
  },
  {
    "codenumber": 79,
    "symbol": "O",
    "description": "LATIN CAPITAL LETTER O"
  },
  {
    "codenumber": 80,
    "symbol": "P",
    "description": "LATIN CAPITAL LETTER P"
  },
  {
    "codenumber": 81,
    "symbol": "Q",
    "description": "LATIN CAPITAL LETTER Q"
  },
  {
    "codenumber": 82,
    "symbol": "R",
    "description": "LATIN CAPITAL LETTER R"
  },
  {
    "codenumber": 83,
    "symbol": "S",
    "description": "LATIN CAPITAL LETTER S"
  },
  {
    "codenumber": 84,
    "symbol": "T",
    "description": "LATIN CAPITAL LETTER T"
  },
  {
    "codenumber": 85,
    "symbol": "U",
    "description": "LATIN CAPITAL LETTER U"
  },
  {
    "codenumber": 86,
    "symbol": "V",
    "description": "LATIN CAPITAL LETTER V"
  },
  {
    "codenumber": 87,
    "symbol": "W",
    "description": "LATIN CAPITAL LETTER W"
  },
  {
    "codenumber": 88,
    "symbol": "X",
    "description": "LATIN CAPITAL LETTER X"
  },
  {
    "codenumber": 89,
    "symbol": "Y",
    "description": "LATIN CAPITAL LETTER Y"
  },
  {
    "codenumber": 90,
    "symbol": "Z",
    "description": "LATIN CAPITAL LETTER Z"
  },
  {
    "codenumber": 91,
    "symbol": "[",
    "description": "LEFT SQUARE BRACKET"
  },
  {
    "codenumber": 92,
    "symbol": "",
    "description": "REVERSE SOLIDUS"
  },
  {
    "codenumber": 93,
    "symbol": "]",
    "description": "RIGHT SQUARE BRACKET"
  },
  {
    "codenumber": 94,
    "symbol": "^",
    "description": "CIRCUMFLEX ACCENT"
  },
  {
    "codenumber": 95,
    "symbol": "_",
    "description": "LOW LINE"
  },
  {
    "codenumber": 96,
    "symbol": "`",
    "description": "GRAVE ACCENT"
  },
  {
    "codenumber": 97,
    "symbol": "a",
    "description": "LATIN SMALL LETTER A"
  },
  {
    "codenumber": 98,
    "symbol": "b",
    "description": "LATIN SMALL LETTER B"
  },
  {
    "codenumber": 99,
    "symbol": "c",
    "description": "LATIN SMALL LETTER C"
  },
  {
    "codenumber": 100,
    "symbol": "d",
    "description": "LATIN SMALL LETTER D"
  },
  {
    "codenumber": 101,
    "symbol": "e",
    "description": "LATIN SMALL LETTER E"
  },
  {
    "codenumber": 102,
    "symbol": "f",
    "description": "LATIN SMALL LETTER F"
  },
  {
    "codenumber": 103,
    "symbol": "g",
    "description": "LATIN SMALL LETTER G"
  },
  {
    "codenumber": 104,
    "symbol": "h",
    "description": "LATIN SMALL LETTER H"
  },
  {
    "codenumber": 105,
    "symbol": "i",
    "description": "LATIN SMALL LETTER I"
  },
  {
    "codenumber": 106,
    "symbol": "j",
    "description": "LATIN SMALL LETTER J"
  },
  {
    "codenumber": 107,
    "symbol": "k",
    "description": "LATIN SMALL LETTER K"
  },
  {
    "codenumber": 108,
    "symbol": "l",
    "description": "LATIN SMALL LETTER L"
  },
  {
    "codenumber": 109,
    "symbol": "m",
    "description": "LATIN SMALL LETTER M"
  },
  {
    "codenumber": 110,
    "symbol": "n",
    "description": "LATIN SMALL LETTER N"
  },
  {
    "codenumber": 111,
    "symbol": "o",
    "description": "LATIN SMALL LETTER O"
  },
  {
    "codenumber": 112,
    "symbol": "p",
    "description": "LATIN SMALL LETTER P"
  },
  {
    "codenumber": 113,
    "symbol": "q",
    "description": "LATIN SMALL LETTER Q"
  },
  {
    "codenumber": 114,
    "symbol": "r",
    "description": "LATIN SMALL LETTER R"
  },
  {
    "codenumber": 115,
    "symbol": "s",
    "description": "LATIN SMALL LETTER S"
  },
  {
    "codenumber": 116,
    "symbol": "t",
    "description": "LATIN SMALL LETTER T"
  },
  {
    "codenumber": 117,
    "symbol": "u",
    "description": "LATIN SMALL LETTER U"
  },
  {
    "codenumber": 118,
    "symbol": "v",
    "description": "LATIN SMALL LETTER V"
  },
  {
    "codenumber": 119,
    "symbol": "w",
    "description": "LATIN SMALL LETTER W"
  },
  {
    "codenumber": 120,
    "symbol": "x",
    "description": "LATIN SMALL LETTER X"
  },
  {
    "codenumber": 121,
    "symbol": "y",
    "description": "LATIN SMALL LETTER Y"
  },
  {
    "codenumber": 122,
    "symbol": "z",
    "description": "LATIN SMALL LETTER Z"
  },
  {
    "codenumber": 123,
    "symbol": "{",
    "description": "LEFT CURLY BRACKET"
  },
  {
    "codenumber": 124,
    "symbol": "|",
    "description": "VERTICAL LINE"
  },
  {
    "codenumber": 125,
    "symbol": "}",
    "description": "RIGHT CURLY BRACKET"
  },
  {
    "codenumber": 126,
    "symbol": "~",
    "description": "TILDE"
  },
  {
    "codenumber": 127,
    "symbol": String.fromCharCode(parseInt('\u007F',16)),
    "description": "DELETE"
  },
  {
    "codenumber": 128,
    "symbol": "Ç",
    "description": "LATIN CAPITAL LETTER C WITH CEDILLA"
  },
  {
    "codenumber": 129,
    "symbol": "ü",
    "description": "LATIN SMALL LETTER U WITH DIAERESIS"
  },
  {
    "codenumber": 130,
    "symbol": "é",
    "description": "LATIN SMALL LETTER E WITH ACUTE"
  },
  {
    "codenumber": 131,
    "symbol": "â",
    "description": "LATIN SMALL LETTER A WITH CIRCUMFLEX"
  },
  {
    "codenumber": 132,
    "symbol": "ä",
    "description": "LATIN SMALL LETTER A WITH DIAERESIS"
  },
  {
    "codenumber": 133,
    "symbol": "à",
    "description": "LATIN SMALL LETTER A WITH GRAVE"
  },
  {
    "codenumber": 134,
    "symbol": "å",
    "description": "LATIN SMALL LETTER A WITH RING ABOVE"
  },
  {
    "codenumber": 135,
    "symbol": "ç",
    "description": "LATIN SMALL LETTER C WITH CEDILLA"
  },
  {
    "codenumber": 136,
    "symbol": "ê",
    "description": "LATIN SMALL LETTER E WITH CIRCUMFLEX"
  },
  {
    "codenumber": 137,
    "symbol": "ë",
    "description": "LATIN SMALL LETTER E WITH DIAERESIS"
  },
  {
    "codenumber": 138,
    "symbol": "è",
    "description": "LATIN SMALL LETTER E WITH GRAVE"
  },
  {
    "codenumber": 139,
    "symbol": "ï",
    "description": "LATIN SMALL LETTER I WITH DIAERESIS"
  },
  {
    "codenumber": 140,
    "symbol": "î",
    "description": "LATIN SMALL LETTER I WITH CIRCUMFLEX"
  },
  {
    "codenumber": 141,
    "symbol": "ì",
    "description": "LATIN SMALL LETTER I WITH GRAVE"
  },
  {
    "codenumber": 142,
    "symbol": "Ä",
    "description": "LATIN CAPITAL LETTER A WITH DIAERESIS"
  },
  {
    "codenumber": 143,
    "symbol": "Å",
    "description": "LATIN CAPITAL LETTER A WITH RING ABOVE"
  },
  {
    "codenumber": 144,
    "symbol": "É",
    "description": "LATIN CAPITAL LETTER E WITH ACUTE"
  },
  {
    "codenumber": 145,
    "symbol": "æ",
    "description": "LATIN SMALL LETTER AE"
  },
  {
    "codenumber": 146,
    "symbol": "Æ",
    "description": "LATIN CAPITAL LETTER AE"
  },
  {
    "codenumber": 147,
    "symbol": "ô",
    "description": "LATIN SMALL LETTER O WITH CIRCUMFLEX"
  },
  {
    "codenumber": 148,
    "symbol": "ö",
    "description": "LATIN SMALL LETTER O WITH DIAERESIS"
  },
  {
    "codenumber": 149,
    "symbol": "ò",
    "description": "LATIN SMALL LETTER O WITH GRAVE"
  },
  {
    "codenumber": 150,
    "symbol": "û",
    "description": "LATIN SMALL LETTER U WITH CIRCUMFLEX"
  },
  {
    "codenumber": 151,
    "symbol": "ù",
    "description": "LATIN SMALL LETTER U WITH GRAVE"
  },
  {
    "codenumber": 152,
    "symbol": "ÿ",
    "description": "LATIN SMALL LETTER Y WITH DIAERESIS"
  },
  {
    "codenumber": 153,
    "symbol": "Ö",
    "description": "LATIN CAPITAL LETTER O WITH DIAERESIS"
  },
  {
    "codenumber": 154,
    "symbol": "Ü",
    "description": "LATIN CAPITAL LETTER U WITH DIAERESIS"
  },
  {
    "codenumber": 155,
    "symbol": "¢",
    "description": "CENT SIGN"
  },
  {
    "codenumber": 156,
    "symbol": "£",
    "description": "POUND SIGN"
  },
  {
    "codenumber": 157,
    "symbol": "¥",
    "description": "YEN SIGN"
  },
  {
    "codenumber": 158,
    "symbol": "₧",
    "description": "PESETA SIGN"
  },
  {
    "codenumber": 159,
    "symbol": "ƒ",
    "description": "LATIN SMALL LETTER F WITH HOOK"
  },
  {
    "codenumber": 160,
    "symbol": "á",
    "description": "LATIN SMALL LETTER A WITH ACUTE"
  },
  {
    "codenumber": 161,
    "symbol": "í",
    "description": "LATIN SMALL LETTER I WITH ACUTE"
  },
  {
    "codenumber": 162,
    "symbol": "ó",
    "description": "LATIN SMALL LETTER O WITH ACUTE"
  },
  {
    "codenumber": 163,
    "symbol": "ú",
    "description": "LATIN SMALL LETTER U WITH ACUTE"
  },
  {
    "codenumber": 164,
    "symbol": "ñ",
    "description": "LATIN SMALL LETTER N WITH TILDE"
  },
  {
    "codenumber": 165,
    "symbol": "Ñ",
    "description": "LATIN CAPITAL LETTER N WITH TILDE"
  },
  {
    "codenumber": 166,
    "symbol": "ª",
    "description": "FEMININE ORDINAL INDICATOR"
  },
  {
    "codenumber": 167,
    "symbol": "º",
    "description": "MASCULINE ORDINAL INDICATOR"
  },
  {
    "codenumber": 168,
    "symbol": "¿",
    "description": "INVERTED QUESTION MARK"
  },
  {
    "codenumber": 169,
    "symbol": "⌐",
    "description": "REVERSED NOT SIGN"
  },
  {
    "codenumber": 170,
    "symbol": "¬",
    "description": "NOT SIGN"
  },
  {
    "codenumber": 171,
    "symbol": "½",
    "description": "VULGAR FRACTION ONE HALF"
  },
  {
    "codenumber": 172,
    "symbol": "¼",
    "description": "VULGAR FRACTION ONE QUARTER"
  },
  {
    "codenumber": 173,
    "symbol": "¡",
    "description": "INVERTED EXCLAMATION MARK"
  },
  {
    "codenumber": 174,
    "symbol": "«",
    "description": "LEFT-POINTING DOUBLE ANGLE QUOTATION MARK"
  },
  {
    "codenumber": 175,
    "symbol": "»",
    "description": "RIGHT-POINTING DOUBLE ANGLE QUOTATION MARK"
  },
  {
    "codenumber": 176,
    "symbol": "░",
    "description": "LIGHT SHADE"
  },
  {
    "codenumber": 177,
    "symbol": "▒",
    "description": "MEDIUM SHADE"
  },
  {
    "codenumber": 178,
    "symbol": "▓",
    "description": "DARK SHADE"
  },
  {
    "codenumber": 179,
    "symbol": "│",
    "description": "BOX DRAWINGS LIGHT VERTICAL"
  },
  {
    "codenumber": 180,
    "symbol": "┤",
    "description": "BOX DRAWINGS LIGHT VERTICAL AND LEFT"
  },
  {
    "codenumber": 181,
    "symbol": "╡",
    "description": "BOX DRAWINGS VERTICAL SINGLE AND LEFT DOUBLE"
  },
  {
    "codenumber": 182,
    "symbol": "╢",
    "description": "BOX DRAWINGS VERTICAL DOUBLE AND LEFT SINGLE"
  },
  {
    "codenumber": 183,
    "symbol": "╖",
    "description": "BOX DRAWINGS DOWN DOUBLE AND LEFT SINGLE"
  },
  {
    "codenumber": 184,
    "symbol": "╕",
    "description": "BOX DRAWINGS DOWN SINGLE AND LEFT DOUBLE"
  },
  {
    "codenumber": 185,
    "symbol": "╣",
    "description": "BOX DRAWINGS DOUBLE VERTICAL AND LEFT"
  },
  {
    "codenumber": 186,
    "symbol": "║",
    "description": "BOX DRAWINGS DOUBLE VERTICAL"
  },
  {
    "codenumber": 187,
    "symbol": "╗",
    "description": "BOX DRAWINGS DOUBLE DOWN AND LEFT"
  },
  {
    "codenumber": 188,
    "symbol": "╝",
    "description": "BOX DRAWINGS DOUBLE UP AND LEFT"
  },
  {
    "codenumber": 189,
    "symbol": "╜",
    "description": "BOX DRAWINGS UP DOUBLE AND LEFT SINGLE"
  },
  {
    "codenumber": 190,
    "symbol": "╛",
    "description": "BOX DRAWINGS UP SINGLE AND LEFT DOUBLE"
  },
  {
    "codenumber": 191,
    "symbol": "┐",
    "description": "BOX DRAWINGS LIGHT DOWN AND LEFT"
  },
  {
    "codenumber": 192,
    "symbol": "└",
    "description": "BOX DRAWINGS LIGHT UP AND RIGHT"
  },
  {
    "codenumber": 193,
    "symbol": "┴",
    "description": "BOX DRAWINGS LIGHT UP AND HORIZONTAL"
  },
  {
    "codenumber": 194,
    "symbol": "┬",
    "description": "BOX DRAWINGS LIGHT DOWN AND HORIZONTAL"
  },
  {
    "codenumber": 195,
    "symbol": "├",
    "description": "BOX DRAWINGS LIGHT VERTICAL AND RIGHT"
  },
  {
    "codenumber": 196,
    "symbol": "─",
    "description": "BOX DRAWINGS LIGHT HORIZONTAL"
  },
  {
    "codenumber": 197,
    "symbol": "┼",
    "description": "BOX DRAWINGS LIGHT VERTICAL AND HORIZONTAL"
  },
  {
    "codenumber": 198,
    "symbol": "╞",
    "description": "BOX DRAWINGS VERTICAL SINGLE AND RIGHT DOUBLE"
  },
  {
    "codenumber": 199,
    "symbol": "╟",
    "description": "BOX DRAWINGS VERTICAL DOUBLE AND RIGHT SINGLE"
  },
  {
    "codenumber": 200,
    "symbol": "╚",
    "description": "BOX DRAWINGS DOUBLE UP AND RIGHT"
  },
  {
    "codenumber": 201,
    "symbol": "╔",
    "description": "BOX DRAWINGS DOUBLE DOWN AND RIGHT"
  },
  {
    "codenumber": 202,
    "symbol": "╩",
    "description": "BOX DRAWINGS DOUBLE UP AND HORIZONTAL"
  },
  {
    "codenumber": 203,
    "symbol": "╦",
    "description": "BOX DRAWINGS DOUBLE DOWN AND HORIZONTAL"
  },
  {
    "codenumber": 204,
    "symbol": "╠",
    "description": "BOX DRAWINGS DOUBLE VERTICAL AND RIGHT"
  },
  {
    "codenumber": 205,
    "symbol": "═",
    "description": "BOX DRAWINGS DOUBLE HORIZONTAL"
  },
  {
    "codenumber": 206,
    "symbol": "╬",
    "description": "BOX DRAWINGS DOUBLE VERTICAL AND HORIZONTAL"
  },
  {
    "codenumber": 207,
    "symbol": "╧",
    "description": "BOX DRAWINGS UP SINGLE AND HORIZONTAL DOUBLE"
  },
  {
    "codenumber": 208,
    "symbol": "╨",
    "description": "BOX DRAWINGS UP DOUBLE AND HORIZONTAL SINGLE"
  },
  {
    "codenumber": 209,
    "symbol": "╤",
    "description": "BOX DRAWINGS DOWN SINGLE AND HORIZONTAL DOUBLE"
  },
  {
    "codenumber": 210,
    "symbol": "╥",
    "description": "BOX DRAWINGS DOWN DOUBLE AND HORIZONTAL SINGLE"
  },
  {
    "codenumber": 211,
    "symbol": "╙",
    "description": "BOX DRAWINGS UP DOUBLE AND RIGHT SINGLE"
  },
  {
    "codenumber": 212,
    "symbol": "╘",
    "description": "BOX DRAWINGS UP SINGLE AND RIGHT DOUBLE"
  },
  {
    "codenumber": 213,
    "symbol": "╒",
    "description": "BOX DRAWINGS DOWN SINGLE AND RIGHT DOUBLE"
  },
  {
    "codenumber": 214,
    "symbol": "╓",
    "description": "BOX DRAWINGS DOWN DOUBLE AND RIGHT SINGLE"
  },
  {
    "codenumber": 215,
    "symbol": "╫",
    "description": "BOX DRAWINGS VERTICAL DOUBLE AND HORIZONTAL SINGLE"
  },
  {
    "codenumber": 216,
    "symbol": "╪",
    "description": "BOX DRAWINGS VERTICAL SINGLE AND HORIZONTAL DOUBLE"
  },
  {
    "codenumber": 217,
    "symbol": "┘",
    "description": "BOX DRAWINGS LIGHT UP AND LEFT"
  },
  {
    "codenumber": 218,
    "symbol": "┌",
    "description": "BOX DRAWINGS LIGHT DOWN AND RIGHT"
  },
  {
    "codenumber": 219,
    "symbol": "█",
    "description": "FULL BLOCK"
  },
  {
    "codenumber": 220,
    "symbol": "▄",
    "description": "LOWER HALF BLOCK"
  },
  {
    "codenumber": 221,
    "symbol": "▌",
    "description": "LEFT HALF BLOCK"
  },
  {
    "codenumber": 222,
    "symbol": "▐",
    "description": "RIGHT HALF BLOCK"
  },
  {
    "codenumber": 223,
    "symbol": "▀",
    "description": "UPPER HALF BLOCK"
  },
  {
    "codenumber": 224,
    "symbol": "α",
    "description": "GREEK SMALL LETTER ALPHA"
  },
  {
    "codenumber": 225,
    "symbol": "ß",
    "description": "LATIN SMALL LETTER SHARP S"
  },
  {
    "codenumber": 226,
    "symbol": "Γ",
    "description": "GREEK CAPITAL LETTER GAMMA"
  },
  {
    "codenumber": 227,
    "symbol": "π",
    "description": "GREEK SMALL LETTER PI"
  },
  {
    "codenumber": 228,
    "symbol": "Σ",
    "description": "GREEK CAPITAL LETTER SIGMA"
  },
  {
    "codenumber": 229,
    "symbol": "σ",
    "description": "GREEK SMALL LETTER SIGMA"
  },
  {
    "codenumber": 230,
    "symbol": "µ",
    "description": "MICRO SIGN"
  },
  {
    "codenumber": 231,
    "symbol": "τ",
    "description": "GREEK SMALL LETTER TAU"
  },
  {
    "codenumber": 232,
    "symbol": "Φ",
    "description": "GREEK CAPITAL LETTER PHI"
  },
  {
    "codenumber": 233,
    "symbol": "Θ",
    "description": "GREEK CAPITAL LETTER THETA"
  },
  {
    "codenumber": 234,
    "symbol": "Ω",
    "description": "GREEK CAPITAL LETTER OMEGA"
  },
  {
    "codenumber": 235,
    "symbol": "δ",
    "description": "GREEK SMALL LETTER DELTA"
  },
  {
    "codenumber": 236,
    "symbol": "∞",
    "description": "INFINITY"
  },
  {
    "codenumber": 237,
    "symbol": "φ",
    "description": "GREEK SMALL LETTER PHI"
  },
  {
    "codenumber": 238,
    "symbol": "ε",
    "description": "GREEK SMALL LETTER EPSILON"
  },
  {
    "codenumber": 239,
    "symbol": "∩",
    "description": "INTERSECTION"
  },
  {
    "codenumber": 240,
    "symbol": "≡",
    "description": "IDENTICAL TO"
  },
  {
    "codenumber": 241,
    "symbol": "±",
    "description": "PLUS-MINUS SIGN"
  },
  {
    "codenumber": 242,
    "symbol": "≥",
    "description": "GREATER-THAN OR EQUAL TO"
  },
  {
    "codenumber": 243,
    "symbol": "≤",
    "description": "LESS-THAN OR EQUAL TO"
  },
  {
    "codenumber": 244,
    "symbol": "⌠",
    "description": "TOP HALF INTEGRAL"
  },
  {
    "codenumber": 245,
    "symbol": "⌡",
    "description": "BOTTOM HALF INTEGRAL"
  },
  {
    "codenumber": 246,
    "symbol": "÷",
    "description": "DIVISION SIGN"
  },
  {
    "codenumber": 247,
    "symbol": "≈",
    "description": "ALMOST EQUAL TO"
  },
  {
    "codenumber": 248,
    "symbol": "°",
    "description": "DEGREE SIGN"
  },
  {
    "codenumber": 249,
    "symbol": "∙",
    "description": "BULLET OPERATOR"
  },
  {
    "codenumber": 250,
    "symbol": "·",
    "description": "MIDDLE DOT"
  },
  {
    "codenumber": 251,
    "symbol": "√",
    "description": "SQUARE ROOT"
  },
  {
    "codenumber": 252,
    "symbol": "ⁿ",
    "description": "SUPERSCRIPT LATIN SMALL LETTER N"
  },
  {
    "codenumber": 253,
    "symbol": "²",
    "description": "SUPERSCRIPT TWO"
  },
  {
    "codenumber": 254,
    "symbol": "■",
    "description": "BLACK SQUARE"
  }
]